import api from './api';
import type {
  Organization,
  OrganizationMember,
  OrganizationUsage,
  CreateOrganizationForm,
} from '@/types';

export const organizationsService = {
  async list(): Promise<Organization[]> {
    const response = await api.get<{ organizations: Organization[] }>('/api/organizations');
    return response.data.organizations;
  },

  async get(id: string): Promise<{ organization: Organization; member_count: number; role: string }> {
    const response = await api.get<{ organization: Organization; member_count: number; role: string }>(`/api/organizations/${id}`);
    return response.data;
  },

  async create(data: CreateOrganizationForm): Promise<Organization> {
    const response = await api.post<{ organization: Organization }>('/api/organizations', data);
    return response.data.organization;
  },

  async update(id: string, data: Partial<Organization>): Promise<Organization> {
    const response = await api.put<{ organization: Organization }>(`/api/organizations/${id}`, data);
    return response.data.organization;
  },

  async delete(id: string): Promise<void> {
    await api.delete(`/api/organizations/${id}`);
  },

  async getUsage(orgId: string): Promise<OrganizationUsage> {
    const response = await api.get<OrganizationUsage>(`/api/organizations/${orgId}/usage`);
    return response.data;
  },

  async getMembers(orgId: string): Promise<OrganizationMember[]> {
    const response = await api.get<{ members: OrganizationMember[] }>(`/api/organizations/${orgId}/members`);
    return response.data.members;
  },

  async addMember(orgId: string, userId: string, role: string): Promise<OrganizationMember> {
    const response = await api.post<{ member: OrganizationMember }>(`/api/organizations/${orgId}/members`, {
      user_id: userId,
      role,
    });
    return response.data.member;
  },

  async updateMemberRole(orgId: string, userId: string, role: string): Promise<OrganizationMember> {
    const response = await api.put<{ member: OrganizationMember }>(`/api/organizations/${orgId}/members/${userId}`, { role });
    return response.data.member;
  },

  async removeMember(orgId: string, userId: string): Promise<void> {
    await api.delete(`/api/organizations/${orgId}/members/${userId}`);
  },
};

export default organizationsService;
